/* SOLVEY · Interactie-states
   ------------------------------------------------------------------
   Eén taak: de add-to-cart laten zien dat hij bezig is.

   Waarom dit nodig is. Het thema heeft een complete `.btn.loading`
   (loading-balk + label verbergen) en zet die ook netjes in zijn eigen
   onFormSubmit. Maar die handler doet daarna:

       if (!purchaseConfirmation && !quickCart) return;   // native POST
       e.preventDefault();                                 // AJAX-pad

   en op deze winkel loopt de PDP altijd via het native POST-pad: het
   formulier post naar /cart/add en de pagina laadt volledig opnieuw.
   Gemeten op de PDP: `.loading` verschijnt nooit, `defaultPrevented`
   blijft false. Tussen klik en nieuwe pagina zat dus geen enkel signaal.

   Dat native pad is hier bewust — solvey-shavebar-pack.js corrigeert het
   formulier expliciet vlak vóór die POST. We veranderen de cart-flow dan
   ook NIET; we zetten alleen de state die het thema al kan tekenen.
   ------------------------------------------------------------------ */
(function () {
  'use strict';

  var ATC = '[data-add-to-cart]';

  function knoppenIn(form) {
    var lijst = form ? form.querySelectorAll(ATC) : [];
    // De sticky koopbalk staat buiten het formulier maar hoort wel mee.
    return Array.prototype.slice.call(lijst);
  }

  function bezig(btn) {
    btn.classList.add('loading');
    btn.setAttribute('aria-busy', 'true');
  }

  function klaar(btn) {
    btn.classList.remove('loading');
    btn.removeAttribute('aria-busy');
  }

  function resetAlles() {
    Array.prototype.forEach.call(document.querySelectorAll(ATC), klaar);
  }

  /* Delegatie op document = bubble-fase, dus we draaien ná elke listener
     die op het formulier zelf zit. Daardoor kunnen we betrouwbaar zien of
     iemand de submit heeft afgevangen. */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('[data-product-form]')) return;

    /* Vangt het thema (of een app) de submit alsnog af, dan komt er geen
       paginawissel en regelt die code zijn eigen state. Niet dubbelop. */
    if (e.defaultPrevented) return;

    var knoppen = knoppenIn(form);
    if (!knoppen.length) return;
    knoppen.forEach(bezig);

    /* Vangnet. Blijft de navigatie uit — geblokkeerde POST, offline,
       een app die later alsnog preventDefault doet — dan staat de knop
       anders voorgoed te draaien. */
    setTimeout(resetAlles, 8000);
  });

  /* ⚠️ Browser-back haalt de pagina uit de bfcache precies zoals hij was:
     mét .loading en aria-busy. De knop is dan onklikbaar terwijl de
     bezoeker denkt dat hij gewoon terug is. `pageshow` met persisted=true
     is het enige signaal dat je daarvoor krijgt; een gewone load-listener
     vuurt niet. visibilitychange vangt het tabblad-terugkeer-geval. */
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) resetAlles();
  });

  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') resetAlles();
  });
})();
